import { post } from 'core_main/request';
import { KustomerErrorResponse } from 'globals/types';
import { PUBNUB_AUTH_ENDPOINT } from './constants';

export const createAuthForTrackingToken = () => {
  return post(PUBNUB_AUTH_ENDPOINT).then((response) => {
    return response;
  });
};

export const backoffAuthCall = (retryCount = 0, delay = 100) => {
  return createAuthForTrackingToken()
    .catch((error: KustomerErrorResponse) => {
      const isNotPubNubNetworkFailure = error?.title !== 'PubNubNetworkFailure';

      if (retryCount === 3 || isNotPubNubNetworkFailure) {
        return Promise.reject(error);
      }

      return new Promise((resolve) => {
        setTimeout(resolve, delay);
      });
    })
    .then((res) => {
      if (res) return res;
      return backoffAuthCall(retryCount + 1, delay * 4);
    });
};
